import { Box, Button, Center, Group, Loader, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconBell, IconRefresh } from '@tabler/icons';
import { NotificationSettingsEditor } from '../../components/notification-settings';
import {
  useGlobalNotificationSettings,
  useSaveGlobalNotificationSettings,
} from '../../queries/use-notification-settings';
import { JsonSection } from '../account-container/common/json-section';

export function NotificationSettingsContainer() {
  const { data, isLoading, isFetching, isError, error, refetch } = useGlobalNotificationSettings();
  const saveGlobal = useSaveGlobalNotificationSettings();

  return (
    <Stack spacing="xl">
      <Box>
        <Group position="apart" align="flex-start" noWrap>
          <Group spacing="md" align="center">
            <ThemeIcon size={42} radius="md" variant="light" color="bagel">
              <IconBell size={22} />
            </ThemeIcon>
            <Box>
              <Title order={2}>Notification settings</Title>
              <Text size="sm" color="dimmed">
                Global defaults. Accounts inherit every switch they do not set themselves.
              </Text>
            </Box>
          </Group>
          <Button
            variant="subtle"
            color="bagel"
            size="sm"
            leftIcon={<IconRefresh size={16} />}
            onClick={() => refetch()}
            loading={isFetching}
          >
            Refresh
          </Button>
        </Group>
      </Box>
      {data ? (
        <>
          <NotificationSettingsEditor
            response={data}
            scope="global"
            saving={saveGlobal.isPending}
            onSave={(changes) => saveGlobal.mutateAsync(changes)}
          />
          <JsonSection title="Stored global document" data={data.stored ?? undefined} />
        </>
      ) : isLoading ? (
        <Center mih={200}>
          <Loader />
        </Center>
      ) : isError ? (
        <Text color="red">
          Failed to load notification settings: {(error as Error)?.message ?? 'Unknown error'}
        </Text>
      ) : (
        <Text color="dimmed">No notification settings found.</Text>
      )}
    </Stack>
  );
}
